<div class="login-page">
  <!-- Left: form -->
  <div class="login-panel">
    <div class="login-panel-inner">
      <div class="login-logo">
        <img alt="Snöball" src="../../../assets/images/blue-logo.png" />
      </div>

      <h1 class="login-welcome">Change Password</h1>

      <div class="login-alert login-alert--info" role="status" aria-live="polite">
        <p>{{ passwordChangeMessage }}</p>
      </div>

      <form (ngSubmit)="onSubmit()" [formGroup]="resetPasswordForm" class="login-form">
        <label class="login-field-label" for="password">Password</label>
        <div class="login-input-wrap">
          <input
            id="password"
            class="login-input"
            [class.login-input--invalid]="submitted && f.password.errors"
            formControlName="password"
            placeholder="••••••••"
            required="required"
            [type]="showPasswords.password ? 'text' : 'password'"
            autocomplete="new-password"
          />
          <button
            type="button"
            class="login-password-toggle"
            [attr.aria-label]="showPasswords.password ? 'Hide password' : 'Show password'"
            (click)="showPasswords.password = !showPasswords.password"
          >
            <i class="fa" aria-hidden="true"
               [ngClass]="{'fa-eye': !showPasswords.password, 'fa-eye-slash': showPasswords.password}"></i>
          </button>
        </div>
        <div *ngIf="submitted && f.password.errors" class="login-field-error">
          <span *ngIf="f.password.errors?.required">Password is required</span>
          <span *ngIf="f.password.errors?.passwordRegex">Invalid Password</span>
        </div>

        <app-password-validation
          class="login-password-strength"
          [password]="f.password.value"
          [email]="passwordContext.email"
          [username]="passwordContext.username"
          [firstName]="passwordContext.first_name"
          [lastName]="passwordContext.last_name"
          [company]="passwordContext.company"
          (onStrengthChanged)="updatePasswordStrength($event)"></app-password-validation>

        <label class="login-field-label" for="confirm_password">Confirm Password</label>
        <div class="login-input-wrap">
          <input
            id="confirm_password"
            class="login-input"
            [class.login-input--invalid]="submitted && f.confirm_password.errors"
            formControlName="confirm_password"
            placeholder="••••••••"
            required="required"
            [type]="showPasswords.confirm_password ? 'text' : 'password'"
            autocomplete="new-password"
          />
          <button
            type="button"
            class="login-password-toggle"
            [attr.aria-label]="showPasswords.confirm_password ? 'Hide password' : 'Show password'"
            (click)="showPasswords.confirm_password = !showPasswords.confirm_password"
          >
            <i class="fa" aria-hidden="true"
               [ngClass]="{'fa-eye': !showPasswords.confirm_password, 'fa-eye-slash': showPasswords.confirm_password}"></i>
          </button>
        </div>
        <div *ngIf="submitted && f.confirm_password.errors" class="login-field-error">
          <span *ngIf="f.confirm_password.errors?.required">Confirm Password is required</span>
          <span *ngIf="f.confirm_password.errors?.confirmPasswordValidator">Password does not match</span>
        </div>

        <button class="login-submit mt-3" type="submit" [disabled]="savePending"
                [attr.aria-busy]="savePending">
          <i *ngIf="savePending" class="fa fa-spinner fa-spin mr-2" aria-hidden="true"></i>
          <span *ngIf="savePending">{{ 'Loginpage.saving' | translate }}</span>
          <span *ngIf="!savePending">Save</span>
        </button>

        <ng-container *ngIf="canSkipForWeek">
          <p class="login-footer-cta mb-0">
            <button class="login-link-button" type="button" [disabled]="deferring"
              (click)="skipForWeek()">{{ 'AuthSecurity.skip_reset_week' | translate:{days: deferralDays} }}</button>
          </p>
          <p class="login-lead login-lead--hint">
            {{ 'AuthSecurity.skip_reset_hint' | translate:{days: deferralDays, left: deferralsLeft} }}
          </p>
        </ng-container>
      </form>

      <p class="login-footer-cta">
        <a class="login-forgot" href="/login" (click)="$event.preventDefault(); backToSignIn()">
          <span aria-hidden="true">←</span> {{ 'Loginpage.back_to_signin' | translate }}
        </a>
      </p>
    </div>
  </div>

  <!-- Right: marketing (desktop) -->
  <app-auth-marketing-panel></app-auth-marketing-panel>
</div>
